import { getCategoriesList } from '@/api/skippay/gcssCategories';
import { slugify } from '@/utils/string';
import {
	Category,
	getCategoryDescriptionAndImage,
	mapSubcategoriesWithDescriptionAndImage,
} from './utils';

export async function getAllPrimaryCategoriesSlugs(): Promise<string[]> {
	const data = await getCategoriesList();

	const categories = data.filter((category) => category.path.length === 1);

	const mappedCategories = categories.map((category) => {
		if (category.path[0]) {
			return slugify(category.path[0]);
		}

		return undefined;
	});

	return mappedCategories.filter(Boolean);
}

export async function getAllPrimaryCategories(): Promise<Category[]> {
	const data = await getCategoriesList();

	const categories = data.filter((category) => category.path.length === 1);

	if (!categories) {
		throw new Error('No categories found');
	}

	const categoriesList = [];

	for (const category of categories) {
		const categorySetting = await getCategoryDescriptionAndImage(category.id);

		categoriesList.push({
			...category,
			subcategories: [],
			name: category.path[0],
			slug: slugify(category.path[0]),
			description: categorySetting ? categorySetting.description : null,
			image: categorySetting ? categorySetting.image : null,
		});
	}

	return categoriesList;
}

export async function getPrimaryCategoryBySlug(slug: string): Promise<Category> {
	const data = await getCategoriesList();

	const primaryCategories = data.filter((category) => category.path.length === 1);

	const category = primaryCategories.find((category) => slugify(category.path[0]) === slug);

	if (!category) {
		throw new Error(`Category with slug ${slug} not found`);
	}

	const categorySetting = await getCategoryDescriptionAndImage(category.id);

	const subCategories = data.filter(
		(categoryItem) => categoryItem.path.length === 2 && categoryItem.path[0] === category.path[0]
	);

	const categoryMap = new Map<number, Category['subcategories'][number]>();

	if (subCategories) {
		for (const subCategory of subCategories) {
			categoryMap.set(subCategory.id, {
				slug: [slugify(subCategory.path[subCategory.path.length - 1])],
				title: subCategory.path[subCategory.path.length - 1],
				image: null,
			});
		}
	}

	const subcategories = await mapSubcategoriesWithDescriptionAndImage(category, categoryMap);

	return {
		...category,
		subcategories,
		name: category.path[0],
		slug: slugify(category.path[0]),
		description: categorySetting?.description || null,
		image: categorySetting?.image || null,
	};
}
